import { IRootState } from 'reducers';

export const selectAllDistrictOptions = (state: IRootState) => {
  const { districtHkiOptions, districtNtOptions, districtKltOptions } = state.locale;
  return {
    ...districtHkiOptions,
    ...districtKltOptions,
    ...districtNtOptions,
  };
}